import Wallet from '@/services/wallet'
import * as types from './mutation-types'
import moment from '@/helpers/date/moment'

export const listWalletHistoric = async ({ commit }, filters) => { 
  const response = await Wallet.listWalletHistoric(filters)
  const walletHistoric = response?.wallet.length > 0 ? response.wallet.sort((a, b) => {
    const dataA = new Date(a?.MOV_DATA?.replace(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/, '$3-$2-$1T$4:$5:$6'))
    const dataB = new Date(b?.MOV_DATA?.replace(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/, '$3-$2-$1T$4:$5:$6'))
    return dataB - dataA
  }) : []
  
  commit(types.GET_WALLET_HISTORIC, { walletHistoric })
  return walletHistoric
}
export const sumWalletTransactions = async ({ commit, state }, filters) => { 
  if(state.cache.totalTransactionsLoaded) {
    return state.totalTransactions
  }
  const response = await Wallet.sumWalletTransactions(filters)
  const totalTransactions = response?.totalTransactions  || []
  commit(types.SUM_WALLET_TRANSACTIONS, { totalTransactions })
  return totalTransactions
}
export const listDiscountCoupons = async ({ commit }, filters) => { 
  const response = await Wallet.getDiscountCoupons(filters)
  let discountCoupons = response?.discountCoupons || []
  discountCoupons = discountCoupons.map((coupon) => ({
    ...coupon,
    TCM_DTVALIDADE: coupon?.TCM_DTVALIDADE  ? moment(coupon.TCM_DTVALIDADE).format('DD/MM/YYYY')  : coupon.TCM_DTVALIDADE,
  })).sort((a, b) => {
    const dataA = new Date(a?.TCM_DTCRIACAO?.replace(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/, '$3-$2-$1T$4:$5:$6'))
    const dataB = new Date(b?.TCM_DTCRIACAO?.replace(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/, '$3-$2-$1T$4:$5:$6'))
    return dataB - dataA
  }) 
  
  commit(types.GET_DISCOUNT_COUPONS, { discountCoupons })
  return discountCoupons
}
export const loadCouponsCampaign = async ({ commit }) => { 
  const response = await Wallet.loadCouponsCampaign()
  const couponsCampaign = response?.couponsCampaign || [] 
  
  commit(types.GET_COUPONS_CAMPAIGN, { couponsCampaign })
  return couponsCampaign
}
export const createTransactionGiftCard = async ({ commit }, fields) => {  
  const response = await Wallet.createTransactionGiftCard(fields)
  return response
}
export const refundGiftCard = async ({ commit }, fields) => {
  const response = await Wallet.refundGiftCard(fields)
  return response
}
export const createCouponVtexModulate = async ({ commit }, fields) => {
  const response = await Wallet.createCouponVtexModulate(fields)
  return response
}